









































































import Component, { mixins } from 'vue-class-component';
import { RootState } from '@/store';
import { mapActions, mapGetters, mapState } from 'vuex';
import { TemplateDetailActions, TemplateDetailGetters } from '@/store/templates/template-detail';
import CoHeader from '@/components/common/CoHeader.vue';
import AuthMixin from '@/components/common/AuthMixin.vue';
import { Watch } from 'vue-property-decorator';
import { templateService } from '@/services/template-service';

@Component({
  components: { CoHeader },
  computed: {
    ...mapGetters({
      currentReleaseState: TemplateDetailGetters.TEMPLATE_CURRENT_RELEASE_STATE
    }),
    ...mapState<RootState>({
      template: (state: RootState) => state.templates.template
    }),
  },
  methods: {
    ...mapActions({
      changeStateTo: TemplateDetailActions.TEMPLATE_DETAIL_RELEASE_STATE_CHANGE,
      createNewVersion: TemplateDetailActions.TEMPLATE_DETAIL_CREATE_NEW_VERSION
    })
  }
})
export default class TemplateDetailHeader extends mixins<AuthMixin>(AuthMixin) {

  showClipboardDialog = false;
  templateHtml = '';

  @Watch('showClipboardDialog')
  loadTemplateHtml() {
    if (this.showClipboardDialog) {
      templateService.loadTemplateAsHtml((this as any).template.versionId).then(result => this.templateHtml = result);
    }
  }

  copyToClipboard() {
    const text = (this.$refs['clipboardContent'] as HTMLElement).innerHTML;

    function listener(e: any) {
      e.clipboardData.setData('text/html', text);
      e.clipboardData.setData('text/plain', text);
      e.preventDefault();
    }

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

}
